import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { UserVerifyOtpPayload } from "../type";

function useVerifyOtp() {
  return useMutation({
    mutationFn: (command: UserVerifyOtpPayload) => {
      return authService.verifyOtp(command);
    },
  });
}

export default useVerifyOtp;
